import React from "react";

import UploadImagesUnits from "Components/Form/UploadImagesUnits";
import PanelContent from "Components/Panels/PanelContent";

export function ImagesPanelV2({
  imageList,
  sendFormData,
  title,
  onDeleteImage,
  previewImages,
}) {
  return (
    <>
      <PanelContent title={title}>
        <div className="row" style={{ justifyContent: "space-around" }}>
          <div className="md-5">
            <label className="text-gray text-semibold text-center">
              {title}
            </label>
            <UploadImagesUnits
              importPath="/product/import"
              fileAccept=".png, .jpg, .jpeg"
              allowExtensions={["png", "jpg", "jpeg"]}
              files={imageList}
              multi
              sendFormData={sendFormData}
            />
          </div>

          {previewImages && previewImages.length > 0 && (
            <div className="grid-img md-4">
              {previewImages.map((item) => {
                return (
                  <div>
                    <span
                      className="delete"
                      key={item.id}
                      onClick={() => onDeleteImage(item.id)}
                    >
                      <img src={item.img} alt="" key={item.id} />
                    </span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </PanelContent>
    </>
  );
}
